module.exports = __webpack_public_path__ + "img/common-hkyw-table@2x.fa9e2efa.png";